var cov_1frgg36gjx = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Progress/Line.tsx",
      hash = "c056a14572eb32881746e840fae110cfa5c7a3e0",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Progress/Line.tsx",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 21
        },
        end: {
          line: 11,
          column: 1
        }
      },
      "1": {
        start: {
          line: 14,
          column: 109
        },
        end: {
          line: 14,
          column: 114
        }
      },
      "2": {
        start: {
          line: 15,
          column: 22
        },
        end: {
          line: 15,
          column: 44
        }
      },
      "3": {
        start: {
          line: 16,
          column: 18
        },
        end: {
          line: 16,
          column: 38
        }
      },
      "4": {
        start: {
          line: 17,
          column: 20
        },
        end: {
          line: 17,
          column: 119
        }
      },
      "5": {
        start: {
          line: 18,
          column: 42
        },
        end: {
          line: 21,
          column: 3
        }
      },
      "6": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 31,
          column: 3
        }
      },
      "7": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 33
        }
      },
      "8": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 41
        }
      },
      "9": {
        start: {
          line: 26,
          column: 9
        },
        end: {
          line: 31,
          column: 3
        }
      },
      "10": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 30,
          column: 13
        }
      },
      "11": {
        start: {
          line: 28,
          column: 18
        },
        end: {
          line: 28,
          column: 39
        }
      },
      "12": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 36
        }
      },
      "13": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 44,
          column: 3
        }
      },
      "14": {
        start: {
          line: 47,
          column: 0
        },
        end: {
          line: 47,
          column: 32
        }
      }
    },
    fnMap: {
      "0": {
        name: "Line",
        decl: {
          start: {
            line: 13,
            column: 9
          },
          end: {
            line: 13,
            column: 13
          }
        },
        loc: {
          start: {
            line: 13,
            column: 36
          },
          end: {
            line: 45,
            column: 1
          }
        },
        line: 13
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 27,
            column: 84
          },
          end: {
            line: 27,
            column: 85
          }
        },
        loc: {
          start: {
            line: 27,
            column: 94
          },
          end: {
            line: 30,
            column: 5
          }
        },
        line: 27
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 14,
            column: 20
          },
          end: {
            line: 14,
            column: 58
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 14,
            column: 34
          },
          end: {
            line: 14,
            column: 58
          }
        }],
        line: 14
      },
      "1": {
        loc: {
          start: {
            line: 16,
            column: 18
          },
          end: {
            line: 16,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 18
          },
          end: {
            line: 16,
            column: 23
          }
        }, {
          start: {
            line: 16,
            column: 27
          },
          end: {
            line: 16,
            column: 38
          }
        }],
        line: 16
      },
      "2": {
        loc: {
          start: {
            line: 17,
            column: 59
          },
          end: {
            line: 17,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 17,
            column: 59
          },
          end: {
            line: 17,
            column: 66
          }
        }, {
          start: {
            line: 17,
            column: 70
          },
          end: {
            line: 17,
            column: 82
          }
        }],
        line: 17
      },
      "3": {
        loc: {
          start: {
            line: 17,
            column: 84
          },
          end: {
            line: 17,
            column: 100
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 17,
            column: 84
          },
          end: {
            line: 17,
            column: 91
          }
        }, {
          start: {
            line: 17,
            column: 95
          },
          end: {
            line: 17,
            column: 100
          }
        }],
        line: 17
      },
      "4": {
        loc: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        }, {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        }],
        line: 23
      },
      "5": {
        loc: {
          start: {
            line: 26,
            column: 9
          },
          end: {
            line: 31,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 26,
            column: 9
          },
          end: {
            line: 31,
            column: 3
          }
        }, {
          start: {
            line: 26,
            column: 9
          },
          end: {
            line: 31,
            column: 3
          }
        }],
        line: 26
      },
      "6": {
        loc: {
          start: {
            line: 29,
            column: 13
          },
          end: {
            line: 29,
            column: 36
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 29,
            column: 17
          },
          end: {
            line: 29,
            column: 30
          }
        }, {
          start: {
            line: 29,
            column: 33
          },
          end: {
            line: 29,
            column: 36
          }
        }],
        line: 29
      },
      "7": {
        loc: {
          start: {
            line: 41,
            column: 7
          },
          end: {
            line: 42,
            column: 113
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 7
          },
          end: {
            line: 41,
            column: 18
          }
        }, {
          start: {
            line: 42,
            column: 9
          },
          end: {
            line: 42,
            column: 112
          }
        }],
        line: 41
      },
      "8": {
        loc: {
          start: {
            line: 42,
            column: 9
          },
          end: {
            line: 42,
            column: 112
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 42,
            column: 17
          },
          end: {
            line: 42,
            column: 51
          }
        }, {
          start: {
            line: 42,
            column: 54
          },
          end: {
            line: 42,
            column: 112
          }
        }],
        line: 42
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Progress/Line.tsx";
import React from 'react';
import classnames from 'classnames';
import { progressClass } from './styles';
import analyzeColor from './analyzeColor';
import Popup from './Popup';
import { isRTL } from '../config';
var DefaultValue = (cov_1frgg36gjx.s[0]++, {
  strokeWidth: 8
});

function Line(props) {
  cov_1frgg36gjx.f[0]++;

  var _ref = (cov_1frgg36gjx.s[1]++, props),
      children = _ref.children,
      _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === void 0 ? (cov_1frgg36gjx.b[0][0]++, DefaultValue.strokeWidth) : _ref$strokeWidth,
      type = _ref.type,
      value = _ref.value,
      color = _ref.color,
      style = _ref.style,
      background = _ref.background,
      popup = _ref.popup;

  var hasChildren = (cov_1frgg36gjx.s[2]++, children !== undefined);
  var isPopup = (cov_1frgg36gjx.s[3]++, (cov_1frgg36gjx.b[1][0]++, popup) && (cov_1frgg36gjx.b[1][1]++, hasChildren));
  var className = (cov_1frgg36gjx.s[4]++, classnames(progressClass('line', type, (cov_1frgg36gjx.b[2][0]++, isPopup) && (cov_1frgg36gjx.b[2][1]++, 'line-popup'), (cov_1frgg36gjx.b[3][0]++, isRTL()) && (cov_1frgg36gjx.b[3][1]++, 'rtl')), props.className));
  var innerStyle = (cov_1frgg36gjx.s[5]++, {
    width: "".concat(value / 100 * 100, "%"),
    borderRadius: strokeWidth / 2
  });
  cov_1frgg36gjx.s[6]++;

  if (typeof color === 'string') {
    cov_1frgg36gjx.b[4][0]++;
    cov_1frgg36gjx.s[7]++;
    innerStyle.background = color;
    cov_1frgg36gjx.s[8]++;
    innerStyle.backgroundSize = '1em 1em';
  } else {
    cov_1frgg36gjx.b[4][1]++;
    cov_1frgg36gjx.s[9]++;

    if (typeof color === 'object') {
      cov_1frgg36gjx.b[5][0]++;
      cov_1frgg36gjx.s[10]++;
      innerStyle.background = "linear-gradient(to right, ".concat(analyzeColor(color).reduce(function (p, v) {
        cov_1frgg36gjx.f[1]++;
        var col = (cov_1frgg36gjx.s[11]++, "".concat(v.color, " ").concat(v.pos));
        cov_1frgg36gjx.s[12]++;
        return p ? (cov_1frgg36gjx.b[6][0]++, "".concat(p, ",").concat(col)) : (cov_1frgg36gjx.b[6][1]++, col);
      }, ''), ")");
    } else {
      cov_1frgg36gjx.b[5][1]++;
    }
  }

  cov_1frgg36gjx.s[13]++;
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: className,
      style: style,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 34,
        columnNumber: 5
      }
    },
    /*#__PURE__*/
    React.createElement("div", {
      className: progressClass('background'),
      style: {
        height: strokeWidth,
        background: background,
        borderRadius: strokeWidth / 2
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 7
      }
    },
    /*#__PURE__*/
    React.createElement("div", {
      className: progressClass('front'),
      style: innerStyle,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 39,
        columnNumber: 9
      }
    })), (cov_1frgg36gjx.b[7][0]++, hasChildren) && (cov_1frgg36gjx.b[7][1]++, popup ? (cov_1frgg36gjx.b[8][0]++,
    /*#__PURE__*/
    React.createElement(Popup, Object.assign({}, props, {
      value: value,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 18
      }
    }))) : (cov_1frgg36gjx.b[8][1]++,
    /*#__PURE__*/
    React.createElement("div", {
      className: progressClass('content'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 55
      }
    }, children))))
  );
}

cov_1frgg36gjx.s[14]++;
Line.defaultProps = DefaultValue;
export default Line;